import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import axios from 'axios';


class Projetos extends Component {

  constructor(props) {
    super(props);
    // Setting up initial state
    this.state = {
      listaItens: []
    }
  }

  // calling the componentDidMount() method after a component is rendered for the first time
  componentDidMount() {

    var th = this;
    axios.get( "http://adm.pixirt.com/api/projetos?_format=json" )
      .then( response => {
        th.setState({ listaItens: response.data.rows });
      })
      .catch( error => {
        console.log(error);
      });

  }

  // calling the componentWillUnMount() method immediately before a component is unmounted from the DOM
  componentWillUnmount() {
    //this.serverRequest.abort();
  }

  render() {

    if(this.state.listaItens.length > 0){
      return (
        <div className="content">
          <h1 className="title">Projetos</h1>
          { this.state.listaItens.map( (item, index) => (
            <div className={"row projeto-item item-" + index} key={item.nid}>
              <div className="col-xs-12">
                <h3 className="titulo">{item.title}</h3>
                <h4 className="datetime">
                  {item.created}
                </h4>
                <div>{ReactHtmlParser(item.body)}</div>
              </div>
            </div>
          ))}
        </div>
      );

    }else{
      return (
        <div className="content">
          <h1 className="title">Projetos</h1>
            <div className="row projeto-item">
              <div className="col-xs-12">
                <h3 className="titulo text-center">Ops! ainda não temos conteúdo publicado!</h3>
              </div>
            </div>
        </div>
      );
    }

  }

}

export default Projetos;

// rendering into the DOM
//ReactDOM.render(
//    <App source="http://adm.pixirt.com/api/artigos?_format=json" />,
//    document.getElementById('container')
//);



// WEBPACK FOOTER //
// ./src/controller/Projetos.js